<h2 mat-dialog-title>{{data?.item ? 'Edit' : 'New'}} classifier</h2>

<form [formGroup]="classifiersForm" (ngSubmit)="handleSubmit()" autocomplete="off">
  <div mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width-input">
      <mat-label>{{'global.code' |translate}}</mat-label>
      <input matInput type="text" [formControl]="codeControl"/>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width-input">
      <mat-label>{{'global.description' |translate}}</mat-label>
      <input matInput type="text" [formControl]="descriptionControl"/>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width-input">
      <mat-label>{{'global.comment' |translate}}</mat-label>
      <input matInput type="text" [formControl]="commentControl"/>
    </mat-form-field>

    <mat-checkbox [formControl]="activeControl" color="primary">
      Active
    </mat-checkbox>
  </div>

  <div mat-dialog-actions class="align-right">
    <button mat-raised-button type="reset" matDialogClose>Close</button>
    <button mat-raised-button type="submit" color="primary" [disabled]="classifiersForm.invalid">Save</button>
  </div>
</form>
